<template>
    <ul
            class="list-reset flex -mb-px lg:overflow-x-hidden overflow-x-auto"
    >
        <li class="pt-1 mr-4" :class="{'opacity-25': !hasItems}">
            <router-link class="btn-nav" to="/chart" accesskey="1">
                <i class="fa fa-line-chart"></i>
                <span class="hidden lg:inline">Chart</span>
            </router-link>
        </li>
        <li class="pt-1 mx-4" :class="{'opacity-25': !hasItems}">
            <router-link class="btn-nav" to="/ranking" accesskey="2">
                <i class="fa fa-video-camera"></i>
                <span class="hidden lg:inline">Motion</span>
            </router-link>
        </li>
        <li class="pt-1 mx-4" :class="{'opacity-25': !hasItems}">
            <router-link class="btn-nav" to="/table" accesskey="3">
                <i class="fa fa-table"></i>
                <span class="hidden lg:inline">Table</span>
            </router-link>
        </li>
    </ul>
</template>

<script>
    export default {
        name: "NavBar",
        computed: {
            hasItems() {
                return this.$store.getters.history.length > 0;
            },
        }
    }
</script>

<style scoped>

</style>
